// extracted by mini-css-extract-plugin
export default {"overlay":"KVMMk3lj0NIOmjNqX06G__overlay___","btn":"MCic3hi10jrR5RcbZtus__btn___"};